<template>
    <div>
        <loading v-if="showLoading"></loading>
        <Breadcrumb v-bind:data="BreadcrumbList"></Breadcrumb>
        <account-status :account_status="account_status"></account-status>

        <div class="widget has-shadow">

            <div class="widget-header bordered d-flex align-items-center">
                <h2>افزودن محصول جدید</h2>
            </div>

            <div class="widget-body">

                 <div v-if="account_status=='active'">

                    <div v-if="errors.length>0" class="alert alert-warning">
                        <ul class="errors_ul">
                            <li :key="key" v-for="(error,key) in errors">{{ error }}</li>
                        </ul>
                    </div>


                     <div class="row flex-row">
                         <div class="col-xl-8">
                             <div class="form-group row d-flex align-items-center">
                                 <div class="col-xl-12">
                                 <label>عنوان فارسی محصول : </label>
                                 <input type="text" class="form-control total_width_input" v-model="title" placeholder="عنوان دسته + برند محصول + مدل + ظرفیت">
                                 </div>
                             </div>

                             <div class="form-group row d-flex align-items-center">
                                 <div class="col-xl-12">
                                 <label>عنوان لاتین محصول : </label>
                                 <input type="text" class="form-control total_width_input" v-model="ename" placeholder="Brand + Model + Category + GB">
                                 <span class="has_error"></span>
                                 </div>
                             </div>

                             <div class="form-group row d-flex align-items-center">
                                 <div class="col-xl-12">
                                 <vue-editor v-model="content"></vue-editor>
                                 </div>
                             </div>

                             <div class="form-group row d-flex align-items-center">
                                 <div class="col-md-12">
                                 <button class="btn btn-success" v-on:click="addProduct()">افزودن محصول</button>
                                 </div>
                             </div>

                         </div>


                         <div class="col-xl-4 " style="background: #f0f2f7;border-radius: 10px;border: 1px solid #dedede;left: 0.5rem">

                                 <div class="form-group row d-flex align-items-center">
                                     <div class="col-md-12 margin-top-15">
                                         <label style="color: #377dff">دسته بندی محصول : </label>
                                     </div>

                                     <div class="col-xl-12" style="padding-left: 0;padding-right: 0; !important">
                                         <div class="select select-color">
                                     <select v-model="catId" ref="cat" class="selectpicker show-menu-arrow col-md-12" data-live-search="true" >
                                         <option v-bind:value="key" :key="key" v-for="(cat,key) in catList">{{ cat }}</option>
                                     </select>
                                        </div>
                                     </div>
                                 </div>

                                 <div class="form-group row d-flex align-items-center">
                                     <div class="col-md-12 margin-top-5">
                                         <label style="color: #377dff">برند محصول : </label>
                                     </div>
                                     <div class="col-xl-12" style="padding-left: 0;padding-right: 0; !important">
                                         <div class="select select-color">
                                     <select v-model="brandId" ref="brand" class="selectpicker show-menu-arrow col-md-12" data-live-search="true" >
                                         <option v-bind:value="brand.id" :key="key" v-for="(brand,key) in brandList">{{ brand.name }} ({{ brand.ename}})</option>
                                     </select>
                                         </div>
                                     </div>
                                 </div>

                             <div class="form-group row d-flex align-items-center">
                                 <div class="col-md-12 margin-top-5">
                                     <label style="color: #377dff">وزن بسته محصول (گرم) : </label>
                                 </div>
                                 <div class="col-xl-12">
                                     <cleave v-model="weight" :options="options" class="form-control w-100 left price_input"></cleave>
                                 </div>
                             </div>

                                 <div class="choice_pic_box" v-on:click="$refs.fileInput.click()">
                                     <span class="title">انتخاب تصویر محصول</span>
                                     <input type="file" ref="fileInput"  name="pic" id="pic" style="display:none" v-on:change="showImage">
                                     <img v-bind:src="image_src"  id="output" class="slider_pic">
                                 </div>

                             <div class="form-group row margin-top-15">
                                 <label class="col-lg-4 form-control-label d-flex justify-content-lg-end">کالای غیر اصلی</label>
                                 <div class="col-lg-5">
                                     <div class="custom-control custom-checkbox styled-checkbox">
                                         <input class="custom-control-input" type="checkbox" v-model="fake" id="check-1">
                                         <label class="custom-control-descfeedback" for="check-1">(این کالا های کپی می باشد)</label>
                                     </div>
                                 </div>
                             </div>

                         </div>

                     </div>



                 </div>
                 <div v-else>
                    <p style="padding-top:100px;text-align:center;font-size:50px">
                      <span class="fa fa-exclamation"></span>
                    </p>
                    <p style="text-align:center;padding-bottom:80px">شما دسترسی لازم برای عملیات جاری را ندارید</p>
                 </div>
             </div>

        </div>
        <server-error-message v-if="server_error"></server-error-message>  
    </div>
</template>

<script>
import Breadcrumb from './Breadcrumb';
import myMinix from '../myMixin';
import AccountStatus from './AccountStatus';
import Loading from './Loading';
import { VueEditor } from "vue2-editor";
import ServerErrorMessage from './ServerErrorMessage'
import Cleave from 'vue-cleave-component';
export default {
    components:{Breadcrumb,Loading,VueEditor,AccountStatus,ServerErrorMessage,Cleave},
    mixins:[myMinix],
    data(){
        return{
            server_error:false,
            BreadcrumbList:[
                { path:'/products',title:'مدیریت محصولات' },
                 {path:'/products/add',title:'افزودن محصول جدید'}
            ],
            options: {
                delimiter: ',',
                numeral: true,
                numeralDecimalScale:3
            },
            catList:[],
            brandList:[],
            colorList:[],
            account_status:'active',
            showLoading:true,
            title:'',
            image_src:'',
            content:'',
            weight:'',
            ename:'',
            catId:0,
            fake:false,
            brandId:1,
            colorId:[],
            image:'',
            errors:[],
            send_form:true
        }
    },
    mounted(){
        this.account_status=localStorage.getItem('account_status');
        this.$emit('setSideBarItem','products');
        this.getCatList();
        this.getBrand();
    },
    methods:{
        showImage:function()
        {
            this.image=this.$refs.fileInput.files[0];
            this.image_src=URL.createObjectURL(this.image);
        },
        addProduct:function(){
            if(this.send_form)
            {
                this.errors=[];
                const validateTitle=this.validateTitle();
                const validateWeight=this.validateWeight();
                const validateContent=this.validateContent();
                const validateCatId=this.validateCatId();
                const validateBrandId=this.validateBrandId();
                const validateImage=this.validateImage();

                if(validateTitle && validateContent && validateCatId && validateBrandId && validateImage && validateWeight)
                {
                    this.showLoading=true;
                    this.send_form=false;
                    const url=this.$siteUrl+'/api/seller/product/create';
                    const formData=new FormData();
                    formData.append('name',this.title);
                    formData.append('description',this.content);
                    formData.append('category',this.catId);
                    formData.append('brand',this.brandId);
                    formData.append('ename',this.ename);
                    formData.append('weight',this.weight);
                    if (this.fake!=false) {
                        formData.append('fake', 1);
                    }
                    formData.append('pic',this.image);

                    this.axios.post(url,formData,this.setHeader(true)).then(response=>{
                        const result=this.setAccountStatus(response.data);
                        console.log(response.data);
                        if(result)
                        {

                            if(response.data=="ok")
                            {
                                this.$router.push({name:'ProductList',params:{success:'ok'}})
                            }
                            else if(response.data.errors!=undefined)
                            {
                                this.errors=response.data.errors;
                            }
                        }
                        this.showLoading=false;
                    }).catch((error)=>{
                        if(error.response.status==401)
                        {
                            this.logout();
                        }
                        else
                        {
                            this.send_form=true;
                            this.showLoading=false;
                            this.show_server_error();
                        }
                    });
                }
            }
        }
    }
}
</script>

<style>

</style>